import React, { useState, useEffect } from 'react';
import '../../assets/css/case-home.css';
// @ts-ignore
import { useContentToken, EditableToken } from '@vibesites/runtime/react';
import { VibesitesImage } from '@vibesites/ui-primitives';

const NAV_LINKS = [
  { href: '/apartments', label: 'Apartments' },
  { href: '/about-us', label: 'About Us' },
  { href: '/careers', label: 'Careers' },
  { href: '/awards', label: 'Awards' },
  // Blog hidden until content is ready for launch
  // { href: '/blog', label: 'Blog' },
  { href: 'https://www.caseusacommercial.com/', label: 'Commercial', target: '_blank' as const },
  { href: 'https://portal.office.com/', label: 'Employee Login', target: '_blank' as const },
];

export function CorporateHeader() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [showHeader, setShowHeader] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  const logo = useContentToken('header.company_logo') as string;
  const logoAlt = useContentToken('header.company_logo_alt') as string;

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY && currentScrollY > 50) {
        setShowHeader(false);
      } else if (currentScrollY < lastScrollY) {
        setShowHeader(true);
      }
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  return (
    <>
      <header className={`case-header${showHeader ? '' : ' header-hidden'}`}>
        <div className="case-header-inner">
          <div className="case-header-logo" style={{ order: 0 }}>
            <a href="/">
              <EditableToken path="header.company_logo" type="image" label="Company Logo">
                <VibesitesImage
                  url={logo}
                  alt={logoAlt}
                  width={160}
                  height={60}
                  objectFit="contain"
                  priority
                />
              </EditableToken>
            </a>
          </div>

          <nav className="case-header-nav" style={{ order: 1 }}>
            {NAV_LINKS.map(l => (
              <a key={l.href} href={l.href} {...(l.target ? { target: l.target, rel: 'noopener noreferrer' } : {})}>{l.label}</a>
            ))}
          </nav>

          <div className="case-header-right" style={{ order: 2 }}>
            <a className="case-header-phone" href="tel:9184921983">(918) 492-1983</a>
            <a className="case-btn" href="/contact-us">Contact Us</a>
            <button
              className="case-hamburger"
              onClick={() => setMobileOpen(true)}
              aria-label="Toggle navigation"
            >
              <span>Menu</span>
              <span className="case-hamburger-lines">
                <span /><span /><span />
              </span>
            </button>
          </div>
        </div>
      </header>

      {/* Mobile overlay + drawer */}
      <div className={`case-overlay${mobileOpen ? ' open' : ''}`} onClick={() => setMobileOpen(false)} />
      <nav className={`case-mobile-nav${mobileOpen ? ' open' : ''}`}>
        <div className="case-mobile-nav-top">
          <a href="/" className="case-mobile-nav-logo" onClick={() => setMobileOpen(false)}>
            <VibesitesImage
              url={logo}
              alt={logoAlt}
              width={120}
              height={45}
              objectFit="contain"
            />
          </a>
          <button className="case-mobile-nav-close" onClick={() => setMobileOpen(false)} aria-label="Close menu">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>

        <div className="case-mobile-nav-links">
          {NAV_LINKS.map(l => (
            <a key={l.href} href={l.href} {...(l.target ? { target: l.target, rel: 'noopener noreferrer' } : {})} onClick={() => setMobileOpen(false)}>{l.label}</a>
          ))}
        </div>

        <div className="case-mobile-nav-contact">
          <a className="case-mobile-nav-phone" href="tel:9184921983">(918) 492-1983</a>
          <a className="case-mobile-nav-cta" href="/contact-us" onClick={() => setMobileOpen(false)}>Contact Us</a>
        </div>
      </nav>
    </>
  );
}

export default CorporateHeader;
